import React from 'react';
import { ExternalLink } from 'lucide-react';
import styles from '../SocialContact.module.css';
import type { socialLink } from '../types.props';

interface socialCardProps {
    social: socialLink;
    onClick: (url: string) => void;
}

export const SocialCard: React.FC<socialCardProps> = ({ social, onClick }) => {
    const IconComponent = social.icon;

    return (
        <article
            className={styles["card-base"]}
            data-color-class={social.colorClass}
            onClick={() => onClick(social.url)}
            role="button"
            tabIndex={0}
            aria-label={`Visitar ${social.name} de ${social.username}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(social.url);
                }
            }}
        >
            <div className={styles["social-card-content"]}>
                <div className={styles["icon-wrapper"]} data-color-class={social.colorClass}>
                    <IconComponent size={32} color="#ffffff" />
                </div>
                <h3 className={styles["card-title"]}>{social.name}</h3>
                <p className={styles["card-username"]}>{social.username}</p>
                <p className={styles["card-description"]}>{social.description}</p>
                <div className={styles["external-icon"]}>
                    <ExternalLink size={20} />
                </div>
            </div>
            <div className={styles.overlay} />
        </article>
    );
};
